export function normalizeTimeValue (value, fallback = '') {
  if (value === null || value === undefined) return fallback

  const text = String(value).trim()
  if (!text) return fallback

  const matched = text.match(/^(\d{1,2}):([0-5]\d)(?::([0-5]\d))?$/)
  if (!matched) return fallback

  const hour = Number(matched[1])
  if (!Number.isInteger(hour) || hour < 0 || hour > 23) return fallback

  return `${String(hour).padStart(2, '0')}:${matched[2]}`
}

export function toApiTimeValue (value) {
  const normalized = normalizeTimeValue(value, '')
  return normalized ? `${normalized}:00` : null
}
